module.exports = __webpack_public_path__ + "src/client/components/LandingPage/img/devices@3x.png";


//////////////////
// WEBPACK FOOTER
// ./src/client/components/LandingPage/img/devices@3x.png
// module id = 1210
// module chunks = 0